import { Component, Injector, OnInit } from '@angular/core';
import { Validators, FormControl } from '@angular/forms';

import { EditItemComponent } from 'app/common/edit-item.component';
import { UsersService } from 'app/components/users/services/users.service';
import { ClubNetsService } from 'app/components/clubnets/services/clubnets.service';
import { ClubsService } from 'app/components/clubs/services/clubs.service';
import { AuthService } from 'app/common/services/auth.service';
import { phoneValidator } from 'app/common/validators/phone.validator';
import { NotEmpty } from 'app/common/validators/required-not-empty.validator';
import { IAccount } from 'app/common/models/account.model';
import { userChatRoute } from 'app/routing/routes/chats.route';
import { CityService } from 'app/common/services/city.service';
import { IRoutingParams } from 'app/common/models/context.model';
import { UserRole } from '../../../common/models/roles.model';
import { ICityModel } from '../../../common/models/city-model';
import { take, takeUntil, filter } from 'rxjs/operators';
import {ContextService} from '../../../common/services/context.service';
import { CoachesService } from 'app/components/coaches/services/coaches.service';
import { ICoachModel } from 'app/common/models/coach.model';
import * as _ from 'lodash';

@Component({
  // tslint:disable-next-line:component-selector
  selector: '[app-user-edit]',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss']
})
export class UserEditComponent extends EditItemComponent<IAccount> implements OnInit {
  public static readonly componentName: string = 'UserEditComponent';

  fieldMessages = {
    firstName: {
      NotEmpty: 'Это поле обязательно',
    },
    lastName: {
      NotEmpty: 'Это поле обязательно',
    },
    email: {
      NotEmpty: 'Это поле обязательно',
      pattern: 'Введите действительный e-mail'
    },
    phoneNumber: {
      NotEmpty: 'Это поле обязательно',
      phoneValidator: 'Введите корректный номер телефона'
    },
    role: {
      required: 'Необходимо выбрать роль',
    },
    clubNetIds: {
      clubNetValidator: 'Необходимо выбрать сеть'
    },
    clubIds: {
      clubsValidator: 'Необходимо выбрать минимум один клуб'
    },
    currentCityId: {
      NotEmpty: 'Это поле обязательно',
    }
  };

  public clubs: Array<Object> = [];
  public clubnets: Array<Object> = [];
  public clubCoaches: { [key: string]: ICoachModel[] } = {} // Словарь клубов и их тренеров
  public coaches: ICoachModel[] = []; // Список доступных тренеров у выбранных клубов
  public cities: Array<ICityModel> = [];
  public isChatShow = false;
  public isSendInviteVisible = false;
  public moduleList: any[] = [];

  constructor(
    injector: Injector,
    protected clubNetsService: ClubNetsService,
    protected service: UsersService,
    private clubsService: ClubsService,
    private cityService: CityService,
    public authService: AuthService,
    private coachesService: CoachesService
  ) {
    super(injector, service);
    this.contextService.contextInfo.pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe(ctx => this.isChatShow = ctx && ctx.modules.includes('chats'));
  }

  public isShowClubs() {
    if (this.form) {
      const currRole = this.form.value.role;
      return currRole === UserRole.ClubManager || currRole === UserRole.ClubAdmin || currRole === UserRole.ClubCoachManager || currRole === UserRole.ClubCoach || currRole === UserRole.ClubCoachAssistant;
    }
    return false;
  }

  public isShowClubNets() {
    if (this.form) {
      const currRole = this.form.value.role;
      return currRole && currRole !== UserRole.Admin && currRole !== UserRole.Manager;
    }
    return false;
  }

  public isMultipleClubs() {
    if (this.form) {
      const currRole = this.form.value.role;
      return true;
    }
    return false;
  }

  public changeRole() {
    if (!this.isShowClubNets()) {
      this.form.patchValue({ clubNetId: [] });
    } else {
      if (this.routingParams.clubNetId) {
        this.Model.clubNetIds[0] = this.routingParams.clubNetId;
        this.changeClubNet(this.routingParams.clubNetId);
        this.form.patchValue({ clubNetIds: [this.routingParams.clubNetId] });
      }
    }
    if (!this.isShowClubs()) {
      this.form.patchValue({ clubIds: null });
      this.Model.clubIds = null;
      this.clubs = [];
    }
    if (!this.isMultipleClubs()) {
      this.Model.clubIds = null;
      this.form.patchValue({ clubIds: this.Model.clubIds });
    }

    if (this.isShowCoaches()) {
      this.changeClubs(this.form.value.clubIds);
    }
    else {
      this.form.patchValue({ coachIds: null });
      this.Model.coachIds = null;
      this.coaches = [];
    }
  }

  public changeClub(clubId: string) {
    this.form.patchValue({ clubIds: clubId ? [clubId] : [] })
  }

  protected async changeClubNet(clubNetId: string) {
    const ctx: IRoutingParams = Object.assign(this.routingParams, { clubNetId })
    await this.clubsService.getClubsByNet(ctx)
      .then(res => {
        this.clubs = res;
        if (this.Model.clubNetIds[0] !== clubNetId) {
          this.form.patchValue({ clubIds: [] });
          this.Model.clubIds = [];
          this.form.patchValue({ coachIds: [] });
          this.Model.coachIds = [];
        }
        this.Model.clubNetIds[0] = clubNetId;
        this.form.patchValue({ clubNetIds: [clubNetId] });
      });
  }

  private clubsValidator = (control: FormControl) => {
    if (this.isShowClubs() && (control.value == null || control.value.length === 0)) {
      return {
        clubsValidator: true
      };
    }
    return null;
  }

  private clubNetValidator = (control: FormControl) => {
    if (this.isShowClubNets() && (control.value == null || control.value.length === 0)) {
      return {
        clubNetValidator: true
      };
    }
    return null;
  }

  buildForm() {
    console.log('buildForm');
    this.form = this.formBuilder.group({
      firstName: [this.Model.firstName, [NotEmpty()]],
      lastName: [this.Model.lastName, [NotEmpty()]],
      email: [this.Model.email, [NotEmpty(), Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]],
      phoneNumber: [this.Model.phoneNumber, [NotEmpty(), phoneValidator()]],
      position: [this.Model.position, []],
      role: [this.Model.role, [Validators.required]],
      clubNetIds: [this.Model.clubNetIds, [this.clubNetValidator]],
      clubIds: [this.Model.clubIds, [this.clubsValidator]],
      coachIds: [this.Model.coachIds, []],
      currentCityId: [this.Model.currentCityId, [NotEmpty()]],
      startScreen: [this.Model.startScreen, []]
    });
    console.log(this.form);
  }

  modelTemplate(): Promise<IAccount> {
    return new Promise(resolve => {
      const template: IAccount = {
        id: null,
        email: null,
        emailConfirmed: false,
        phoneNumberConfirmed: false,
        firstName: null,
        lastName: null,
        position: null,
        role: null,
        clubIds: [],
        clubNetIds: [],
        coachIds: [],
        currentCityId: null,
        startScreen: null
      };

      this.cityService.currentCity.pipe(
        takeUntil(this.ngUnsubscribe),
        filter<ICityModel>(Boolean),
        take(1))
        .subscribe(city => {
          // TODO: по идее, нужно очищать сеть клубов и клубы при смене города, но сейчас сети не привязаны к городу, так что пока так.
          template.currentCityId = city.id;
          resolve(template);
        })
    })
  }

  public async initChatWith(event) {
    event.preventDefault();
    const _url = userChatRoute.path
      .replace(':cityId', this.Model.currentCityId)
      .replace(':id', this.Model.id);
    this.router.navigateByUrl(_url);
  }

  public async afterModelInit() {
    if (this.Model.clubNetIds && this.Model.clubNetIds.length) {
      await this.changeClubNet(this.Model.clubNetIds[0]);
    }

    if (this.Model.clubIds && this.Model.clubIds.length) {
      this.changeClubs(this.Model.clubIds);
    }
  }

  async ngOnInit() {
    super.ngOnInit();
    this.cityService.getItemList()
      .then(cities => this.cities = cities);
    this.cityService.currentCity.pipe(
      takeUntil(this.ngUnsubscribe),
      filter<ICityModel>(Boolean),
      take(1))
      .subscribe(city => {
        this.clubNetsService.getItemList(city)
          .then(res => this.clubnets = res.items);
      })
    await this.contextService.availableModulesList().then(resp => {
      this.moduleList = resp;
    });
  }

  getModulesByRole() {
    return this.moduleList.filter(x => x.role === this.form.get('role').value)[0].modules.sort((x, y) => {
      if (x.title < y.title) { return -1; }
      if (x.title > y.title) { return 1; }
    });
  }

  sendInvite() {
    this.service.apiV2Service.accounts.sendInvite(this.Model.id);
  }

  public isShowCoaches() {
    if (this.form) {
      const currRole = this.form.value.role;
      return currRole === UserRole.ClubCoachManager || currRole === UserRole.ClubCoach || currRole === UserRole.ClubCoachAssistant;
    }
    return false;
  }

  async getCoachesByClub(club: { id: string, cityId: string }) {
    const context: IRoutingParams = Object.assign(this.routingParams, { clubId: club.id, cityId: club.cityId })
    return await this.coachesService.getCoachesByClub(context);
  }

  /**
   * Извлекает и возвращает значения из списка опций `<select multiple>`
   */
  parseMultipleSelectValues(options: HTMLCollection) {
    return Array.from(options).map((option: HTMLOptionElement) => {
      let [index, value] = option.value.split(':');
      value = value.replace(/[\s\']/g, '');
      return value;
    });
  }

  changeCoaches(coachIds: string[]) {
    this.Model.coachIds = coachIds;
  }

  async changeClubs(clubIds: string[]) {
    clubIds ??= [];

    if (this.isShowCoaches()) {
      await this.loadClubCoaches(clubIds);
      this.coaches = this.createCoaches(clubIds);
      this.filterSelectedCoaches();
    }
  }

  /**
   * Загружает тренеров по указанным клубам и добавляет в словарь `clubCoaches`.
   * Если информация по клубу уже присутствует в словаре, то повторная загрузка не производится.
   * @param coachIds Клубы, по которым нужно загрузить тренеров.
   */
  async loadClubCoaches(clubIds: string[]) {
    if (this.clubCoaches == null) this.clubCoaches = {};

    const clubIdsToLoad = clubIds.filter(clubId => !this.clubCoaches[clubId]);

    if (clubIdsToLoad.length) {
      const clubCoaches = await Promise.all(
        clubIdsToLoad.map(clubId => {
          const club = this.clubs.find((club: any) => club.id == clubId) as any;
          return this.getCoachesByClub(club);
        })
      );
      for (let i = 0; i < clubIdsToLoad.length; i++) {
        const clubId = clubIdsToLoad[i];
        const coaches = clubCoaches[i];
        this.clubCoaches[clubId] = coaches;
      }
    }
  }

  /**
   * Возвращает список доступных тренеров на основе выбранных клубов.
   */
  createCoaches(clubIds: string[]) {
    const coaches: ICoachModel[] = [];

    clubIds.forEach(clubId => {
      this.clubCoaches[clubId].forEach(coach => {
        if (!coaches.some(ch => ch.id == coach.id)) coaches.push(coach);
      })
    });

    // Если sortOrder указан, то сортируем по нему. Иначе по ФИО.
    coaches.sort((a, b) => {
      if (a.sortOrder != null && b.sortOrder == null) return -1;
      if (a.sortOrder == null && b.sortOrder != null) return 1;
      if (a.sortOrder != b.sortOrder) return Number(a.sortOrder) - Number(b.sortOrder);
      return `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`);
    });

    return coaches;
  }

  /**
   * Удаляет из модели и формы тех тренеров, которых нет в списке тренеров выбранных клубов `coaches`.
   */
  filterSelectedCoaches() {
    const selectedCoachIds = this.form.value.coachIds;
    const filteredCoachIds = selectedCoachIds.filter((id: string) => this.coaches.some(c => c.id == id));
    this.Model.coachIds = filteredCoachIds;
    this.form.patchValue({ coachIds: filteredCoachIds });
  }
}
